import ArchivedCvsPage from "../features/cv-processor/ArchivedCvsPage";

export default function ArchivedCvsRoute() {
  return <ArchivedCvsPage />;
}
